// The API session token, sent as a bearer token. Session storage keeps it per tab and drops it
// when the tab closes; the API enforces idle and absolute expiry on its side.
const SESSION_TOKEN_KEY = 'a6tr_session';

export const getSessionToken = (): string | undefined => {
	try {
		return sessionStorage.getItem(SESSION_TOKEN_KEY) ?? undefined;
	} catch {
		return undefined;
	}
};

export const setSessionToken = (token: string) => {
	try {
		sessionStorage.setItem(SESSION_TOKEN_KEY, token);
	} catch {
		// Storage unavailable (e.g. blocked): the user will be asked to sign in again.
	}
};

export const clearSessionToken = () => {
	try {
		sessionStorage.removeItem(SESSION_TOKEN_KEY);
	} catch {
		// Nothing to clear.
	}
};
